<template>
  <v-dialog v-model="dialog" width="800">
    <template v-slot:activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on">CLOA STATUS</span>
    </template>

    <v-card>
      <v-card-title>CLOA Status</v-card-title>

      <v-card-text>
        <v-row>
          <v-col>
            <p class="mb-1 text-caption">CLOA Status</p>
            <p><b>{{item.cloa_status | notEmpty}}</b></p>
            <p class="mb-1 text-caption">CLOA Signed</p>
            <p><b>{{item.cloa_signed | notEmpty}}</b></p>
            <p class="mb-1 text-caption">CLOA Sent</p>
            <p><b>{{item.cloa_sent | notEmpty}}</b></p>
          </v-col>
          <v-col>
            <p class="mb-1 text-caption">CLOA Document Id</p>
            <p><b>{{item.cloa_document_id | notEmpty}}</b></p>
            <p class="mb-1 text-caption">CLOA Document Link</p>
            <p><b><a :href="item.cloa_document_link | notEmptyLink" target="_blank">View Document</a></b></p>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small outlined class="ml-3" :disabled="getSendCloaLoading" @click="dialog = false">CLOSE</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: { item: { type: Object } },
  data() {
    return {
      dialog: false,
    }
  },
  computed: { ...mapGetters("numbers", ["getSendCloaLoading", "getSendCloaError"]), },
  filters: {
    notEmpty: function(val) { return (val === null || val === "" || val === undefined)?'-':val; },
    notEmptyLink: function(val) { return (val === null || val === "" || val === undefined)?'#':val; },
  },
  methods: {
    ...mapActions("numbers", ["sendCloa"]),
    async submit(data) {
      try {
        await this.sendCloa(data);
        this.dialog = false;
      } catch(err) {
        return err;
      }
    },
  },
}
</script>

<style>
</style>
